import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../../core/api/api.service';
import { COUPONS_ENDPOINTS } from '../../../../core/api/endpoints/coupons.endpoints';

@Injectable({
  providedIn: 'root',
})
export class CouponsService {
  private api = inject(ApiService);

  getCouponClassifications(): Observable<any> {
    return this.api.get(COUPONS_ENDPOINTS.V1.COUPON_CLASSIFICATIONS).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getDiscountTypes(): Observable<any> {
    return this.api.get(COUPONS_ENDPOINTS.V1.COUPON_DISCOUNT_TYPES).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  addNewCoupon(coupon): Observable<any> {
    return this.api.post(COUPONS_ENDPOINTS.V1.COUPONS, coupon).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getCouponById(id): Observable<any> {
    return this.api.get<any>(COUPONS_ENDPOINTS.V1.COUPON_DETAIL(id)).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  getCoupons(): Observable<any> {
    return this.api.get(COUPONS_ENDPOINTS.V1.COUPONS).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  updateCoupon(id, coupon): Observable<any> {
    return this.api
      .put<any>(COUPONS_ENDPOINTS.V1.COUPON_DETAIL(id), coupon)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  deleteCoupon(id): Observable<any> {
    return this.api
      .delete(COUPONS_ENDPOINTS.V1.DELETE_COUPON, { body: id })
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

  getCouponsByPage(query): Observable<any> {
    return this.api.get(COUPONS_ENDPOINTS.V1.COUPONS, { params: query }).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
}
